<template>
  <div class="w-full !h-full py-4 lg:py-6 rounded-md">
    <div class="flex justify-start lg:justify-end lg:p-2 py-2 gap-2 lg:gap-4">
      <div class="flex items-center">
        <form
          @submit.prevent="searchCampaign"
          class="flex gap-2 lg:gap-4 w-full"
        >
          <input
            type="text"
            name="campaign_search"
            id="campaign_search"
            v-model="campaign_search"
            placeholder="Search by name"
            class="rounded-lg w-[70%] lg:w-[250px]"
          />
          <button type="submit" class="btn text-sm px-4 py-2 rounded-lg">
            Search
          </button>
        </form>
      </div>
      <button @click="addCampain = true" class="btn px-4 py-2 rounded-lg">
        Add+
      </button>
    </div>
    <div v-if="loader == false">
      <div v-if="campaignList.length > 0" class="w-full overflow-scroll">
        <table class="min-w-full bg-primary2 shadow-md">
          <thead class="bg-primary border-b text-start sticky top-0 text">
            <tr class="text-left whitespace-nowrap">
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                S.No
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Campaign Name
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Description
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Start Date
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                End Date
              </th>
              <th
                scope="col"
                class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="campaignList.length <= 0">
              <td></td>
              <td class="px-4 py-2 xl:px-6 xl:py-4 text-left">{{ message }}</td>
            </tr>
            <tr
              v-else
              class="text-left border-b !whitespace-nowrap"
              v-for="(campaigns, index) in campaignList"
              :key="index"
            >
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                {{ (currentPage - 1) * perPage + index + 1 }}
              </td>
              <td class="px-4 py-2 xl:px-6 xl:py-4">{{ campaigns.name }}</td>
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                <p>{{ campaigns.description }}</p>
              </td>
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                {{ formatDate(campaigns.start_date) }}
              </td>
              <td class="px-4 py-2 xl:px-6 xl:py-4">
                {{ formatDate(campaigns.end_date) }}
              </td>
              <td class="whitespace-nowrap px-4 py-2 xl:px-6 xl:py-4 relative">
                <div class="inline-flex items-center justify-center">
                  <button
                    @click="toggleEdit(campaigns.id)"
                    class="size-8 rounded-full mt-1 p-0 hover:bg-slate-300/20 focus:bg-slate-300/20 active:bg-slate-300/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="size-4.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                      />
                    </svg>
                  </button>
                  <div
                    class="absolute -left-[110px] top-4 w-[130px] z-50"
                    v-show="popupId === campaigns.id"
                  >
                    <div
                      class="popper-box rounded-md border border-slate-150 bg-white py-0 font-inter dark:border-navy-500 dark:bg-navy-700"
                    >
                      <ul>
                        <li @click="sendEmailBatch(campaigns.id)">
                          <p
                            class="flex h-6 items-center px-3 pr-4 cursor-pointer font-medium tracking-wide outline-none transition-all hover:bg-[#2563eb] hover:text-white focus:bg-slate-100 focus:text-slate-800 text-xs"
                          >
                            Start
                          </p>
                        </li>
                        <li
                          @click="
                            editCampagin(campaigns.id);
                            editCampaginStatus = true;
                          "
                        >
                          <p
                            class="flex h-6 items-center px-3 pr-4 cursor-pointer font-medium tracking-wide outline-none transition-all hover:bg-[#2563eb] hover:text-white focus:bg-slate-100 focus:text-slate-800 text-xs"
                          >
                            Edit
                          </p>
                        </li>
                        <!-- <li @click="deleteCampaign(campaigns.id, campaigns.name)">
                      <p
                        class="flex h-6 items-center px-3 pr-4 cursor-pointer font-medium tracking-wide outline-none transition-all hover:bg-[#2563eb] hover:text-white focus:bg-slate-100 focus:text-slate-800 text-xs"
                      >
                        Delete
                      </p>
                    </li> -->
                      </ul>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot class="bg-primary border-b text">
            <tr class="">
              <td colspan="6" class="px-4 py-2 xl:px-6 xl:py-4">
                <div class="w-full flex justify-between items-center">
                  <h2 class="">
                    Showing {{ first_value }} to {{ last_value }}
                  </h2>
                  <h2 class="">
                    Page {{ total_std_list.current_page_number }} of
                    {{ total_std_list.total_pages }}
                  </h2>
                  <div class="">
                    <button
                      v-if="camp_prev"
                      @click="prevCamapign"
                      class="btn px-2 py-1 rounded-md"
                    >
                      prev
                    </button>
                    <button
                      v-if="camp_next"
                      @click="nextCamapign"
                      class="btn px-2 py-1 rounded-md"
                    >
                      next
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
        <!-- Pagination -->
      </div>
      <div v-else style="height: calc(100vh - 80px)">
        <div class="flex flex-col justify-center items-center h-full">
          <img
            :src="no_data"
            class="w-full h-[500px] object-contain"
            alt=""
            srcset=""
          />
          <h1 class="text-black text-lg">NO DATA FOUND</h1>
        </div>
      </div>
    </div>
    <!-- add campaign popup  -->
    <div
      v-if="addCampain"
      class="flex items-center justify-center w-full h-full fixed top-0 left-0 z-50 bg-black bg-opacity-60"
    >
      <div
        class="bg-white p-6 gap-y-5 flex flex-col justify-center items-center w-full lg:w-[500px] rounded-xl relative !z-999"
      >
        <div class="flex justify-between w-full">
          <h2>Add Campaign</h2>
          <span
            @click="addCampain = false"
            class="font-semibold text-lg hover:text-red-700 cursor-pointer"
            >x</span
          >
        </div>

        <div class="">
          <form
            action=""
            @submit.prevent="campaignCreate"
            class="flex flex-col gap-2 lg:gap-3 justify-start"
          >
            <div class="flex flex-col text-start">
              <label for="campaignName"
                >Campaign Name <span class="span-color">*</span></label
              >
              <input
                v-model="name"
                id="updatedName"
                type="text"
                placeholder="campaign name"
                required
                class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              />
            </div>
            <div class="flex flex-col text-start">
              <label for="campaignDescription"
                >Description <span class="span-color">*</span></label
              >
              <textarea
                name="campaignDescription"
                id="campaignDescription"
                cols="30"
                v-model="description"
                rows="10"
                placeholder="add description"
                required
                class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              ></textarea>
            </div>
            <div class="flex flex-col text-start">
              <label for="startDate"
                >Start Date <span class="span-color">*</span></label
              >
              <input
                v-model="start_date"
                id="startDate"
                type="date"
                required
                class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              />
            </div>
            <div class="flex flex-col text-start">
              <label for="endDate"
                >End Date <span class="span-color">*</span></label
              >
              <input
                v-model="end_date"
                id="endDate"
                type="date"
                required
                class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              />
            </div>

            <div class="flex justify-center pt-3">
              <button type="submit" class="w-40 px-4 py-2 btn rounded-md">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- edit campaign -->
    <div
      v-if="editCampaginStatus == true"
      class="flex items-center justify-center w-full h-full fixed top-0 left-0 z-50 bg-black bg-opacity-60"
    >
      <div
        class="bg-white p-5 lg:p-6 gap-y-5 flex flex-col justify-center items-center w-full lg:w-[500px] rounded-xl relative !z-999"
      >
        <div class="p-2 lg:p-8 w-full text-lg h-full">
          <div class="flex justify-between items-center mb-4">
            <h2 class="text-xl font-semibold text-black">Update Campign</h2>
            <span
              @click="editCampaginStatus = false"
              class="font-semibold text-lg hover:text-red-700 cursor-pointer"
              >x</span
            >
          </div>
          <form
            action=""
            @submit.prevent="updateCampaign"
            class="flex flex-col gap-2 lg:gap-3 justify-start w-full"
          >
            <div class="flex flex-col text-start">
              <label for="campaignName">Campaign Name</label>
              <input
                v-model="update_name"
                id="updatedName"
                type="text"
                class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              />
            </div>
            <div class="flex flex-col text-start">
              <label for="campaignDescription">Description</label>
              <textarea
                name="campaignDescription"
                id="campaignDescription"
                cols="30"
                v-model="update_description"
                rows="8"
                placeholder="add description"
                class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              ></textarea>
            </div>
            <div class="flex flex-col text-start">
              <label for="startDate">Start Date</label>
              <input
                v-model="update_start_date"
                id="startDate"
                type="date"
                class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              />
            </div>
            <div class="flex flex-col text-start">
              <label for="endDate">End Date</label>
              <input
                v-model="update_end_date"
                id="endDate"
                type="date"
                class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
              />
            </div>

            <div class="flex justify-center pt-3">
              <button type="submit" class="w-40 px-4 py-2 btn rounded-md">
                Submit
              </button>
            </div>
          </form>
          <div v-if="updateValue">
            <p class="text-lg font-semibold">{{ updateValue }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- start campaign  -->
    <div
      @click="closeModal"
      v-if="coming_soon == true"
      class="flex items-center justify-center w-full h-full fixed top-0 left-0 z-50 bg-black bg-opacity-60"
    >
      <div
        class="p-5 lg:p-6 gap-y-5 flex flex-col justify-center items-center w-full lg:w-[500px] rounded-xl relative !z-999"
      >
        <div class="p-2 lg:p-8 w-full text-lg h-full">
          <div
            class="w-full lg:w-[500px] h-[300px] lg:h-[500px] flex justify-center items-center"
          >
            <img
              :src="coming_soon_img"
              alt="coming soon image"
              class="object-contain rounded-xl"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="loader" class="flex flex-col justify-center items-center">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      Loading...
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "CampaignView",
  data() {
    return {
      message: "",
      addCampain: false,
      campaignList: [],
      popupId: "",
      loader: false,
      name: "",
      description: "",
      start_date: "",
      end_date: "",
      update_name: "",
      update_description: "",
      update_start_date: "",
      update_end_date: "",
      editCampaginStatus: false,
      updateCampaigns: [],
      campaign_id: "",
      email_id: "",
      coming_soon: false,
      currentPage: 1,
      perPage: 20,
      next: require(`${process.env.VUE_APP_NEXT}`),
      back: require(`${process.env.VUE_APP_BACK}`),
      no_data: require(`${process.env.VUE_APP_NODATA}`),
      coming_soon_img: require(`${process.env.VUE_APP_COMING_SOON}`),
      campaign_search: "",
      total_std_list: "",
      current_page_number: 1,
      first_value: 1,
      last_value: 20,
      camp_next: "",
      camp_prev: "",
      total_pages: "",
      count: 0,
      remaing: "",
    };
  },
  async created() {
    await this.getCampaign();
    this.loader = true;
  },
  computed: {
    ...mapGetters(["userInfo", "isAuthenticated"]),
  },
  methods: {
    sendEmailBatch(id) {
      this.email_id = id;
      this.coming_soon = true;
    },
    closeModal(event) {
      if (event.target === event.currentTarget) {
        this.coming_soon = false;
      }
      this.popupId = null;
    },
    // get campaign list
    async getCampaign() {
      axios
        .get(
          `${process.env.VUE_APP_API}/campaign/list/?Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.data.status == 200) {
            console.log("resp 475", resp);
            this.total_std_list = resp.data;
            this.camp_next = resp.data.next;
            this.camp_prev = resp.data.previous;
            this.current_page_number = resp.data.current_page_number;
            this.total_pages = resp.data.total_pages;
            this.campaignList = resp.data.data.data;
            this.message = resp.data.data.message;
            this.count = resp.data.count;
            if (this.last_value > this.count) {
              this.remaing = this.last_value - this.count;
              this.last_value = this.last_value - this.remaing;
              console.log("remaing", this.remaing);
            }
            console.log("this.count 479", this.count);
            console.log("this.campaignList 476", this.campaignList);
            setTimeout(() => {
              this.loader = false;
            }, 1000);
          } else if (resp.data.data.status == 400) {
            setTimeout(() => {
              this.loader = false;
            }, 1000);
          }
        })
        .catch((err) => {
          console.log("error ", err);
        });
    },
    // next campaign list
    async nextCamapign() {
      await axios
        .get(`${this.camp_next}`)
        .then((resp) => {
          console.log("resp 253", resp);
          this.total_std_list = resp.data;
          this.campaignList = resp.data.data;
          this.camp_next = resp.data.next;
          this.camp_prev = resp.data.previous;
          this.current_page_number = resp.data.current_page_number;
          this.first_value = (this.current_page_number - 1) * 20 + 1;
          this.last_value = this.current_page_number * 20;
          this.total_pages = resp.data.total_pages;
          this.loader = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // previous campaign list
    async prevCamapign() {
      await axios
        .get(`${this.camp_prev}`)
        .then((resp) => {
          this.total_std_list = resp.data;
          this.campaignList = resp.data.data;
          this.camp_next = resp.data.next;
          this.camp_prev = resp.data.previous;
          this.current_page_number = resp.data.current_page_number;
          this.total_pages = resp.data.total_pages;
          this.first_value = (this.current_page_number - 1) * 20 + 1;
          this.last_value = (this.last_value / 20 - 1) * 20;
          this.loader = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // search campaign
    searchCampaign() {
      axios
        .get(
          `${process.env.VUE_APP_API}/campaign/list/?search=${this.campaign_search}&Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.data.status == 200) {
            this.campaignList = resp.data.data.data;
            this.message = resp.data.data.message;
            // this.loader = false;
          }
        })
        .catch((err) => {
          console.log("error ", err);
        });
    },
    editCampagin(id) {
      this.campaign_id = id;
      this.editCampaginStatus = true;
      axios
        .get(
          `${process.env.VUE_APP_API}/campaign/list/?id=${id}&Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.updateCampaigns = resp.data.data.data;
            const formatDate = (dateString) => {
              return new Date(dateString).toISOString().slice(0, 10);
            };
            this.update_name = this.updateCampaigns[0].name;
            this.update_description = this.updateCampaigns[0].description;
            this.update_start_date = formatDate(
              this.updateCampaigns[0].start_date
            );
            this.update_end_date = formatDate(this.updateCampaigns[0].end_date);
            this.message = resp.data.message;
            this.popupId = "";
          }
        })
        .catch((err) => {
          console.log("error ", err);
        });
    },
    updateCampaign() {
      const campaignData = {
        name: this.update_name,
        description: this.update_description,
        start_date: this.formatUpdateDate(this.update_start_date),
        end_date: this.formatUpdateDate(this.update_end_date),
        created_by: `${this.userInfo.data.user.id}`,
      };
      axios
        .put(
          `${process.env.VUE_APP_API}/campaign/update-destroy/${this.campaign_id}/?Key=${this.userInfo.data.token}`,
          campaignData
        )
        .then((resp) => {
          if (resp.status == 200) {
            this.editCampaginStatus = false;
            this.getCampaign();
            this.update_name = "";
            this.update_description = "";
            this.update_start_date = "";
            this.update_end_date = "";

            // this.popupId = "";
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    campaignCreate() {
      const campaignData = {
        name: this.name,
        description: this.description,
        start_date: this.formatUpdateDate(this.start_date),
        end_date: this.formatUpdateDate(this.end_date),
        created_by: `${this.userInfo.data.user.id}`,
      };
      axios
        .post(
          `${process.env.VUE_APP_API}/campaign-create/post/?Key=${this.userInfo.data.token}`,
          campaignData
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.addCampain = false;
            this.getCampaign();
            this.popupId = "";
            this.name = "";
            this.description = "";
            this.start_date = "";
            this.end_date = "";
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    toggleEdit(id) {
      if (this.popupId === id) {
        this.popupId = null;
      } else {
        this.popupId = id;
      }
    },
    // YYYY-MM-DDThh:mm
    formatUpdateDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    },
    formatDate(dateString) {
      if (!dateString) return "Invalid Date";
      const date = new Date(dateString);

      const dateOptions = { month: "short", day: "2-digit", year: "numeric" };
      const timeOptions = {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
        timeZone: "Asia/Kolkata",
      };

      const formattedDate = date.toLocaleDateString("en-IN", dateOptions);
      const formattedTime = date.toLocaleTimeString("en-IN", timeOptions);

      return `${formattedDate} / ${formattedTime}`;
    },
    // pagenation
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
};
</script>

<style></style>
